import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import type { Job, JobDraft } from '@etnrlz-jobs/shared';
import { api } from '../lib/api';
import { ErrorBox, PageHeader, Spinner } from '../components/ui';
import { JobForm } from '../components/JobForm';

export function JobEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [job, setJob] = useState<Job | null>(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api<{ job: Job }>(`/admin/jobs/${id}`)
      .then((r) => setJob(r.job))
      .catch((e: Error) => setError(e.message));
  }, [id]);

  const save = async (d: JobDraft) => {
    setSaving(true);
    setError('');
    try {
      await api(`/admin/jobs/${id}`, { method: 'PUT', body: d });
      navigate(`/vagas/${id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao salvar');
      setSaving(false);
    }
  };

  return (
    <div>
      <PageHeader title="Editar vaga" subtitle={job?.title} />
      {error && (
        <div className="mb-4">
          <ErrorBox message={error} />
        </div>
      )}
      {!job && !error && (
        <div className="flex justify-center py-16">
          <Spinner className="h-6 w-6" />
        </div>
      )}
      {job && <JobForm initial={job} onSave={save} saving={saving} saveLabel="Salvar alterações" />}
    </div>
  );
}
